<template>
  <div class="scanner_wrapper">
    <button @click="start">Start</button>
    <button @click="stop">Stop</button>
    <div ref="quagga" class="camera" />
    <vue-scroll class="scroller detail">
      <div style="height: 320px;">
        <pre v-if="data">
      {{ data }}
    </pre>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import Quagga from "quagga";
export default {
  name: "Scanner",
  data: () => ({
    data: null,
    code: null
  }),
  mounted() {
    this.$nextTick(() => {
      Quagga.init(
        {
          inputStream: {
            name: "Live",
            type: "LiveStream",
            target: this.$refs.quagga,
            constraints: {
              width: { min: 340 },
              height: { min: 280 },
              aspectRatio: { min: 1, max: 100 },
              facingMode: "environment" // or "user" for the front camera
            }
          },
          locator: {
            patchSize: "medium",
            halfSample: true
          },
          numOfWorkers: navigator.hardwareConcurrency
            ? navigator.hardwareConcurrency
            : 4,
          decoder: {
            readers: ["ean_reader", "upc_reader"],
            debug: {
              drawBoundingBox: false
            }
          },
          locate: true
        },
        () => this.start()
      );
    });
  },
  methods: {
    start() {
      Quagga.onProcessed(this.onProcessed);
      Quagga.onDetected(this.onDetected);
      Quagga.start();
      console.log("Quagga started!");
    },
    onProcessed(result) {
      var drawingCtx = Quagga.canvas.ctx.overlay,
        drawingCanvas = Quagga.canvas.dom.overlay;

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(
            0,
            0,
            parseInt(drawingCanvas.getAttribute("width")),
            parseInt(drawingCanvas.getAttribute("height"))
          );
          result.boxes
            .filter(function(box) {
              return box !== result.box;
            })
            .forEach(function(box) {
              Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                color: "green",
                lineWidth: 2
              });
            });
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
            color: "#00F",
            lineWidth: 2
          });
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(
            result.line,
            { x: "x", y: "y" },
            drawingCtx,
            { color: "red", lineWidth: 3 }
          );
        }
      }
    },
    onDetected(data) {
      if (data.codeResult.code) {
        this.data = data.codeResult;
        var audio = new Audio(require("@/assets/sounds/beep-07.mp3")); // path to file
        audio.play();
        this.stop();
      }
    },
    stop() {
      Quagga.offDetected(this.onDetected);
      Quagga.stop();
      this.$refs.quagga.querySelector("video").remove();
      this.$refs.quagga.querySelector("canvas").remove();
    }
  }
};
</script>

<style>
.scanner-wrapper {
  width: 80vh;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
}
/* .camera {
  border: 1px solid red;
  max-height: 300px;
  display: block;
} */
</style>
